import { Navigate, Route } from "react-router-dom";
import React from "react";

//先对routes做一次合并处理 将相同父级下的children合并到一起
const collapseRoutes = (beforeRoutes: any = []) => {
  const routes: any = [];
  for (let item of beforeRoutes) {
    let findRouteIndex = routes.findIndex(
      (route: any) =>
        route.path === item.path &&
        route.children?.length > 0 &&
        item.children?.length > 0
    );

    if (findRouteIndex >= 0) {
      routes[findRouteIndex].children.push(...item.children);
    } else {
      routes.push(item);
    }
  }

  return routes;
};

//获取routes集合
export const getRoutes = (routes: any) => {
  return routes.map((item: any) => {
    return (
      <Route
        path={item.path}
        key={item.path}
        element={
          item.redirect && !item.children ? (
            <Navigate to={item.redirect} />
          ) : (
            item.element
          )
        }
      >
        {item.redirect && item.children ? (
          <Route
            path={item.path}
            element={<Navigate to={item.redirect} />}
          ></Route>
        ) : (
          ""
        )}
        {item.children && item.children.length ? getRoutes(item.children) : ""}
      </Route>
    );
  });
};

//获得最终合并后的Routes
export const getFinallyRoutes = (beforeRoutes_: any) => {
  let beforeRoutes = [...beforeRoutes_];
  let routes = collapseRoutes(beforeRoutes);
  return getRoutes(routes);
};

//用以tab匹配的routes 讲嵌套拆分成单条路由 目前只处理了一层children
export const getTabRoutes = (beforeRoutes: any = []) => {
  let routes: any = [];
  beforeRoutes.forEach((route: any) => {
    //有子路由
    if (route.children?.length > 0) {
      route.children.forEach((innerRoute: any) => {
        routes.push({
          path: route.path + "/" + innerRoute.path,
          name: innerRoute.name,
          key: innerRoute.key,
        });
      });
    } else {
      //没有子路由
      routes.push({ path: route.path, name: route.name, key: route.key });
    }
  });

  return routes;
};
